/* eslint-disable import/no-anonymous-default-export */
import { RouteObject } from "react-router-dom";
import {
  USER,
  USER_MANAGEMENT_ADMIN_GROUP_CREATE,
  USER_MANAGEMENT_ADMIN_GROUP_DETAILS,
  USER_MANAGEMENT_DETAILS,
  USER_MANAGEMENT_OVERVIEW,
  USER_MANAGEMENT_PERMISSION_DETAILS,
  USER_MANAGEMENT_PROFILE_CREATE,
  USER_MANAGEMENT_PROFILE_DETAILS,
} from "../../constants/urls";

/** @type {import('react-router-dom').RouteObject[]} */
export default [
  {
    path: USER,
    lazy: () => import("./routes/UserManagementList"),
  },
  {
    path: USER_MANAGEMENT_PROFILE_CREATE,
    lazy: () => import("./routes/UserManagementProfileCreateEdit"),
  },
  {
    path: USER_MANAGEMENT_PROFILE_DETAILS,
    lazy: () => import("./routes/UserManagementProfileDetails"),
  },
  {
    path: USER_MANAGEMENT_DETAILS,
    lazy: () => import("./routes/UserManagementDetails"),
  },
  {
    path: USER_MANAGEMENT_OVERVIEW,
    lazy: () => import("./routes/UserManagementOverview"),
  },
  {
    path: USER_MANAGEMENT_ADMIN_GROUP_CREATE,
    lazy: () => import("./routes/UserManagementAdminGroupCreate"),
  },
  {
    path: USER_MANAGEMENT_ADMIN_GROUP_DETAILS,
    lazy: () => import("./routes/UserManagementAdminGroupDetails"),
  },
  {
    path: USER_MANAGEMENT_PERMISSION_DETAILS,
    lazy: () => import("./routes/UserManagementPermissionDetails"),
  },
] as RouteObject[];
